<template>
  <b-form-group
      class="bold-label"
      :label="title"
      label-for="tags-with-dropdown"
  >
    <b-form-tags
        id="tags-with-dropdown"
        v-model="tagsValue"
        :limit="1"
        no-outer-focus
        class="mb-2"
        :state="stateTagsValue"
    >
      <template v-slot="{ tags, disabled, addTag, removeTag }">

        <b-dropdown dropup size="sm" variant="thirdly-outlined" block menu-class="w-100" v-if="tags.length <= 0">
          <template #button-content style="color: white" >
            Selectionnez une adresse d'intervention
          </template>

          <b-dropdown-item-button
              v-for="option in availableOptions"
              :key="option.id"
              @click="onOptionClick({ option, addTag })"
          >
            {{ option.name }} <strong>{{ (option.tenant && option.tenant.name) ? `(${option.tenant.name})` : ((option.owner && option.owner.name) ? `(${option.owner.name})` : ((option.agency && option.agency.name) ? `(${option.agency.name})` : "")) }}</strong>
          </b-dropdown-item-button>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-text v-if="availableOptions.length === 0">
            Aucune adresse trouvée
          </b-dropdown-text>
          <b-dropdown-form
              @submit.stop.prevent="() => {}"
          >
            <b-form-group
                label="Recherche"
                label-for="tag-search-input"
                label-cols-md="auto"
                class="mb-0"
                label-size="sm"
                :description="searchDesc"
                :disabled="disabled"
            >
              <b-form-input
                  v-model="search"
                  id="tag-search-input"
                  type="search"
                  size="sm"
                  autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </b-dropdown-form>
        </b-dropdown>
        <ul v-if="tags.length > 0" class="list-inline mb-2">
          <li v-for="tag in tags" :key="tag">
            <b-form-tag
                @remove="removeTag(tag)"
                no-remove
                :title="tag"
                :disabled="disabled"
                style="color:#2D3849; background-color:#C8CBCF; width: 100%; height: 40px; align-items: center !important; position: relative;"
            ><span v-html="tag"></span>
              <span><x-icon class="removeTag" @click="removeTag(tag)"></x-icon></span>
            </b-form-tag>
          </li>
        </ul>
      </template>
    </b-form-tags>
    <template #invalid-feedback>
      <div style="color:var(--main-color)">
      Vous devez selectionner une adresse d'intervention
      </div>
    </template>
  </b-form-group>
</template>

<script>
import _ from "lodash";
import api from "@/services/api";

export default {
  name: "SelectAutoCompleteField",

  props: {
    urlData: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    initValue: {
      type: Object
    }
  },

  emits: [
    'setTagValue'
  ],

  data() {
    return {
      search: '',
      tagsValue: [],
      availableOptions: [],
      addressIntervention: null
    }
  },

  computed: {
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return "Il n'y a pas de résultat"
      }
      return ''
    },

    stateTagsValue() {
      return this.tagsValue.length === 1
    }
  },

  watch: {
    search: _.debounce(function (addr) {
      this.getData(addr)
    }, 500),

    'tagsValue': function () {
      this.$emit('setTagValue', this.tagsValue.length === 1 ? this.addressIntervention : null)
    },

    'initValue': function () {
      if (this.initValue) {
        this.addressIntervention = this.initValue
        this.tagsValue = [this.initValue.name]
      }
    }
  },

  methods: {
    onOptionClick({option, addTag}) {
      addTag(option.name)
      this.addressIntervention = option
      this.search = ''
    },

    async getData(word) {
      let data = new FormData()
      data.append('word', word)
      let me=this;
      api({
        method: 'POST',
        url: this.urlData,
        data: data,
      }).then((suggestions) => {
        this.availableOptions = suggestions.data
        window.dispatchEvent(new Event('resize'))
      })
    },
  },
}
</script>

<style scoped>
.was-validated .form-control:invalid, .form-control.is-invalid{
  background-image:none;
  padding-right:0.75rem !important;
  border-width: 0;
  border-color:var(--main-color);
}

.was-validated .form-control:valid, .form-control.is-valid{
  background-image:none;
  padding-right:0.75rem !important;
  border-width: 0;
  padding-bottom: inherit;
}

.removeTag{
  position: absolute;
  right: 2px;
  top: 8px;
}

.removeTag:hover{
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/SelectAutoCompleteField.vue